import { render } from "./LoaderPopup.vue?vue&type=template&id=78834d65&scoped=true&ts=true"
import script from "./LoaderPopup.vue?vue&type=script&lang=ts"
export * from "./LoaderPopup.vue?vue&type=script&lang=ts"

import "./LoaderPopup.vue?vue&type=style&index=0&id=78834d65&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78834d65"]])

export default __exports__